import {Component} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-open-notification-confirmation-popup',
  templateUrl: './open-notification-confirmation-popup.component.html',
  styleUrls: ['./open-notification-confirmation-popup.component.css']
})
export class OpenNotificationConfirmationPopupComponent {
  constructor(private dialogRef: MatDialogRef<OpenNotificationConfirmationPopupComponent>) {
  }

  closeNotification(navigate: boolean) {
    this.dialogRef.close({navigate: navigate});
  }
}
